<template>
	<el-form label-width="120px" :model="formData"  ref="formRef">
		<!-- 派单时间 -->
		<el-form-item label="派单时间" prop="dispatchTime" >
			<el-date-picker v-model="formData.dispatchDate" type="datetime" placeholder="选择派单时间" style="width: 100%"
				value-format="yyyy-MM-dd HH:mm:ss" />
		</el-form-item>

		<el-form-item label="主状态" prop="stateMainText" :rules="[{required: true,message: '请选择主状态', trigger: 'change'}]">
		  <el-input disabled :value="formData.stateMainText" class="input-small" placeholder="" size="small"/>
		</el-form-item>
		
		<el-form-item label="子状态" prop="stateSubText" :rules="[{required: true,message: '请选择子状态类型', trigger: 'change'}]">
		  <el-input disabled :value="formData.stateSubText" class="input-small" placeholder="" size="small"/>
		</el-form-item>
		
		
		<el-form-item label="主标签" prop="interruptStatus" :rules="[{required: false,message: '请选择主标签', trigger: 'change'}]">
		  <el-select v-model="formData.interruptStatus" class="filter-item input-small" placeholder="请选择主标签" size="small" filterable @change="changLabel">
		    <el-option v-for="(item,index) in orderInterruptStatusOptions" :key="item.id" :label="item.name" :value="item.id"/>
		  </el-select>
		</el-form-item>
		
		<el-form-item label="子标签" v-if="showlabel"  prop="interruptSubStatus" :rules="[{required: false,message: '请选择子标签', trigger: 'change'}]">
		  <el-select v-model="formData.interruptSubStatus" class="filter-item input-small" placeholder="请选择子标签" size="small" filterable clearable >
		    <el-option v-for="(item,index) in orderInterruptSubStatusOptions" :key="item.id" :label="item.name" :value="item.id"/>
		  </el-select>
		</el-form-item>
		
		<el-form-item label="报桩状态" prop="interruptStatusText" :rules="[{required: false,message: '请选择报桩状态', trigger: 'change'}]">
		  <el-select v-model="formData.reportChargeStatus" class="filter-item input-small" placeholder="请选择报桩状态" size="small" filterable clearable >
		    <el-option v-for="(item,index) in orderReportChargeStatusOptions" :key="index" :label="item" :value="item"/>
		  </el-select>
		</el-form-item>

		<!-- 主标签 -->
		<!-- <el-form-item label="主标签" prop="mainTag">
			<el-select v-model="form.mainTag" placeholder="请选择主标签" style="width: 100%">
				<el-option label="请选择主标签" value="" disabled />
				<el-option label="重要客户" value="重要客户" />
				<el-option label="一般客户" value="一般客户" />
			</el-select>
		</el-form-item> -->

		<!-- 子标签 -->
		<!-- <el-form-item label="子标签" prop="subTag">
			<el-select v-model="form.subTag" placeholder="请选择子标签" style="width: 100%">
				<el-option label="请选择子标签" value="" disabled />
				<el-option label="新客户" value="新客户" />
				<el-option label="老客户" value="老客户" />
			</el-select>
		</el-form-item> -->

		<!-- 报桩状态 -->
		<!-- <el-form-item label="报桩状态" prop="pileStatus">
			<el-select v-model="form.pileStatus" placeholder="请选择报桩状态" style="width: 100%">
				<el-option label="请选择报桩状态" value="" disabled />
				<el-option label="已报桩" value="已报桩" />
				<el-option label="未报桩" value="未报桩" />
			</el-select>
		</el-form-item> -->

		<el-form-item label="发桩日期" v-if="formData.type ==='INSTALL_ORDER'"  prop="fzDate" >
		  <el-date-picker v-model="formData.fzDate" placeholder="" style="width: 200px" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
		  </el-date-picker>
		</el-form-item>
		<el-form-item label="运单号" v-if="formData.type ==='INSTALL_ORDER'"  prop="ydNo" >
		  <el-input  v-model="formData.ydNo" class="input-small" size="small"/>
		</el-form-item>
		<el-form-item label="桩码" v-if="formData.type ==='INSTALL_ORDER'"  prop="zmNo" >
		  <el-input  v-model="formData.zmNo" class="input-small" size="small"/>
		</el-form-item>


		<el-button type="primary" @click="submitForm">提交</el-button>
	</el-form>
</template>

<script>
	import request from '../utils/request'
	
	// 服务包级联数据（示例）
	const packageOptions = [{
			value: '预勘测',
			label: '预勘测',
			children: [{
					value: '标准包',
					label: '标准包'
				},
				{
					value: '高级包',
					label: '高级包'
				}
			]
		},
		{
			value: '正常',
			label: '正常下单',
			children: [{
					value: '基础包',
					label: '基础包'
				},
				{
					value: '全配包',
					label: '全配包'
				}
			]
		}
	]

	export default {
		props: {
			formData: {
				type: Object,
				required: true,
				default: () => ({}) // 默认值
			}
		},
		data() {
			return {
				orderInterruptStatusOptions:[],
				orderInterruptSubStatusOptions:[],
				orderReportChargeStatusOptions:[],
				packageOptions,
				cascaderProps: {
					label: 'label',
					value: 'value',
					children: 'children'
				},
				form: {
					dispatchTime: '',
					customerService: '',
					packageSource: '',
					servicePackage: [],
					groupBuilt: '是',
					partyAMatch: '否',
					customerWill: '',
					mainStatus: '',
					subStatus: '',
					mainTag: '',
					subTag: '',
					pileStatus: '',
					writtenOff: false,
					incomePrice: 0,
					settlementPrice: 0,
					penaltySubsidy: 0
				},
				formData: {},
				showlabel:false,

			}
		},
		watch: {
			formData: {
				handler(newVal) {
					
					this.$forceUpdate();
				},
				deep: true // 深度监听对象内部变化
			}
		},
		mounted() {

		},
		created() {
			this.getLabelList();
			this.orderReportChargeStatusOptions = ['资料未开始准备','准备资料','挂桩','暂无电表申请条件','已提交资料','电表已勘测','电表已安装','无需报装']
		
		},
		methods: {
			submitForm() {
				const res = request.post('/applets/qywx/save_handler',this.formData)
				.then(response => {
					this.$message({
					         message: '保存成功',
					         type: 'success'
					       });
				})
				.catch(error => {
				  console.error('请求失败:', error)
				  return null // 返回默认值，避免链式调用中断
				})
			},
			resetForm() {
				this.$refs.formRef.resetFields()
			},
			/**
			 * 选择了主标签 子标签
			 */
			changLabel(row){
			 
				const res = request.get('/applets/qywx/getLabelListById?id='+row)
				.then(response => {
					 this.formData.interruptSubStatus=''
					 this.orderInterruptSubStatusOptions = response.data;
				 this.showlabel = true;
				   this.$forceUpdate();
				})
				.catch(error => {
				  console.error('请求失败:', error)
				  return null // 返回默认值，避免链式调用中断
				})
			
			},
			/**
			 * 获取主标签
			 * @returns {Promise<void>}
			 */
			 getLabelList(){
				 const res = request.get('/applets/qywx/LabelList')
				 .then(response => {
					 
				 	 this.orderInterruptStatusOptions = response.data;
					 if(this.formData.interruptStatus){
						 this.changLabel(this.formData.interruptStatus)
						 
					 }
				   this.$forceUpdate();
				 })
				 .catch(error => {
				   console.error('请求失败:', error)
				   return null // 返回默认值，避免链式调用中断
				 })
		
			  // console.log(this.sourceOption)
			}
		}
	}
</script>